// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".subscriptions-disclosure_heading{display:flex;align-items:center;justify-content:space-between}.subscriptions-horizontal-list_item{display:flex;align-items:stretch;height:auto}.t-subscriptions-disclosure{font-size:16px}@media(min-width:640px){.t-subscriptions-disclosure{font-size:calc(1vw + 9.6px)}}@media(min-width:1440px){.t-subscriptions-disclosure{font-size:24px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
